import { useState } from 'react';
import { resendVerificationEmail, reloadCurrentUser, userNeedsEmailVerification } from '../utils/auth';

const VerifyEmailPage = ({ email, onVerified, onSignOut }) => {
  const [sending, setSending] = useState(false);
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResend = async () => {
    setSending(true);
    setError('');
    setMessage('');
    try {
      await resendVerificationEmail();
      setMessage('Verification email sent. Please check your inbox and spam folder.');
    } catch (err) {
      setError(err.message || 'Could not send verification email.');
    } finally {
      setSending(false);
    }
  };

  const handleCheck = async () => {
    setChecking(true);
    setError('');
    setMessage('');
    try {
      const user = await reloadCurrentUser();
      if (!userNeedsEmailVerification(user)) {
        onVerified?.(user);
        return;
      }
      setMessage('Email not verified yet. Click the link in your inbox, then try again.');
    } catch (err) {
      setError(err.message || 'Could not refresh verification status.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <h1>Confirm your email</h1>
        <p>We sent a confirmation link to secure your account before you can invest or list properties.</p>
        <ul className="auth-features">
          <li><i className="fas fa-check-circle"></i> Protects your wallet and investments</li>
          <li><i className="fas fa-check-circle"></i> Required for new email and Google sign-ups</li>
          <li><i className="fas fa-check-circle"></i> Link expires after a short time — resend if needed</li>
        </ul>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h2>Check your inbox</h2>
          <p className="subtitle">
            {email
              ? <>We emailed a confirmation link to <strong>{email}</strong>.</>
              : 'We emailed a confirmation link to your address.'}
          </p>
          <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '0.75rem' }}>
            Open the link in the same browser, then return here and click &ldquo;I&rsquo;ve verified my email&rdquo;.
          </p>
          <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
            If you don&rsquo;t see it within a minute, check your spam/junk folder and mark it as &ldquo;Not spam&rdquo;.
          </p>
          {error ? <div className="form-error" style={{ marginBottom: '1rem' }}>{error}</div> : null}
          {message ? (
            <div style={{ marginBottom: '1rem', color: 'var(--primary)', fontSize: '0.9rem' }}>{message}</div>
          ) : null}
          <button
            type="button"
            className="btn btn-primary"
            style={{ width: '100%', padding: '0.9rem', marginBottom: '0.75rem' }}
            onClick={handleCheck}
            disabled={checking}
          >
            {checking ? 'Checking…' : "I've verified my email"}
          </button>
          <button
            type="button"
            className="btn btn-outline"
            style={{ width: '100%', padding: '0.9rem', marginBottom: '0.75rem' }}
            onClick={handleResend}
            disabled={sending}
          >
            {sending ? 'Sending…' : 'Resend confirmation email'}
          </button>
          <button
            type="button"
            className="btn btn-outline"
            style={{ width: '100%', padding: '0.9rem' }}
            onClick={onSignOut}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
